import apiClient from "../../Network/client";
import { LoginRequest, User } from "../types/auth";
import { jwtDecode } from "jwt-decode";

interface JWTPayload {
  companyId: string;
  name: string;
  role: string;
}

export const login = async (
  credentials: LoginRequest,
): Promise<{
  user: User;
  token: string;
  message: string;
  success: boolean;
  companyId?: string;
}> => {
  const response = await apiClient.post("auth/login", credentials);
  const data = response.data.data;

  const decoded = jwtDecode<JWTPayload>(data.token);

  return {
    user:      data.user,
    token:     data.token,
    message:   response.data.message,
    success:   response.data.success,
    companyId: decoded.companyId,
  };
};

export const logout = async (): Promise<void> => {
  await apiClient.post("auth/logout");
  sessionStorage.removeItem("accessToken");
  sessionStorage.removeItem("user");
  sessionStorage.removeItem("selectedCompany");
};

export const getCurrentUser = async (): Promise<User> => {
  const response = await apiClient.get<{
    success: boolean;
    data: { user: User };
  }>("/auth/me");
  return response.data.data.user;
};

export const refreshToken = async (): Promise<string> => {
  const response = await apiClient.post<{
    success: boolean;
    data: { token: string };
  }>("auth/refresh-token");
  return response.data.data.token;
};
